module.exports = __webpack_public_path__ + "img/待收货.984a58d2.svg";